var _defs, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21, _rect22, _rect23, _rect24, _rect25, _rect26, _rect27, _rect28, _rect29, _rect30, _rect31, _rect32, _rect33, _rect34, _rect35, _rect36, _rect37, _rect38, _rect39, _rect40, _rect41, _rect42, _rect43, _rect44, _rect45, _rect46, _rect47, _rect48, _rect49, _rect50, _rect51, _rect52, _rect53, _rect54, _rect55, _rect56, _rect57, _rect58, _rect59, _rect60, _path, _g, _g2, _g3, _path2, _path3, _path4, _path5, _g4, _g5, _path6, _path7, _path8, _path9, _path10, _polygon, _path11, _polygon2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSituationSac(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_7",
    "data-name": "Calque 7",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 3000.5 3004.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-69,.cls-70,.cls-72,.cls-73,.cls-74,.cls-75{fill:none;}.cls-10,.cls-11,.cls-12,.cls-13,.cls-14,.cls-15,.cls-16,.cls-17,.cls-18,.cls-19,.cls-2,.cls-20,.cls-21,.cls-22,.cls-23,.cls-24,.cls-25,.cls-26,.cls-27,.cls-28,.cls-29,.cls-3,.cls-30,.cls-31,.cls-32,.cls-33,.cls-34,.cls-35,.cls-36,.cls-37,.cls-38,.cls-39,.cls-4,.cls-40,.cls-41,.cls-42,.cls-43,.cls-44,.cls-45,.cls-46,.cls-47,.cls-48,.cls-49,.cls-5,.cls-50,.cls-51,.cls-52,.cls-53,.cls-54,.cls-55,.cls-56,.cls-57,.cls-58,.cls-59,.cls-6,.cls-7,.cls-8,.cls-9{stroke:#594b45;}.cls-10,.cls-11,.cls-12,.cls-13,.cls-14,.cls-15,.cls-16,.cls-17,.cls-18,.cls-19,.cls-2,.cls-20,.cls-21,.cls-22,.cls-23,.cls-24,.cls-25,.cls-26,.cls-27,.cls-28,.cls-29,.cls-3,.cls-30,.cls-31,.cls-32,.cls-33,.cls-34,.cls-35,.cls-36,.cls-37,.cls-38,.cls-39,.cls-4,.cls-40,.cls-41,.cls-42,.cls-43,.cls-44,.cls-45,.cls-46,.cls-47,.cls-48,.cls-49,.cls-5,.cls-50,.cls-51,.cls-52,.cls-53,.cls-54,.cls-55,.cls-56,.cls-57,.cls-58,.cls-59,.cls-6,.cls-69,.cls-7,.cls-70,.cls-72,.cls-73,.cls-74,.cls-75,.cls-77,.cls-79,.cls-8,.cls-81,.cls-9{stroke-miterlimit:10;}.cls-2{fill:url(#D\xE9grad\xE9_sans_nom_157);}.cls-3{fill:url(#D\xE9grad\xE9_sans_nom_157-2);}.cls-4{fill:url(#D\xE9grad\xE9_sans_nom_157-3);}.cls-5{fill:url(#D\xE9grad\xE9_sans_nom_157-4);}.cls-6{fill:url(#D\xE9grad\xE9_sans_nom_157-5);}.cls-7{fill:url(#D\xE9grad\xE9_sans_nom_157-6);}.cls-8{fill:url(#D\xE9grad\xE9_sans_nom_157-7);}.cls-9{fill:url(#D\xE9grad\xE9_sans_nom_157-8);}.cls-10{fill:url(#D\xE9grad\xE9_sans_nom_157-9);}.cls-11{fill:url(#D\xE9grad\xE9_sans_nom_157-10);}.cls-12{fill:url(#D\xE9grad\xE9_sans_nom_157-11);}.cls-13{fill:url(#D\xE9grad\xE9_sans_nom_157-12);}.cls-14{fill:url(#D\xE9grad\xE9_sans_nom_157-13);}.cls-15{fill:url(#D\xE9grad\xE9_sans_nom_157-14);}.cls-16{fill:url(#D\xE9grad\xE9_sans_nom_157-15);}.cls-17{fill:url(#D\xE9grad\xE9_sans_nom_157-16);}.cls-18{fill:url(#D\xE9grad\xE9_sans_nom_157-17);}.cls-19{fill:url(#D\xE9grad\xE9_sans_nom_157-18);}.cls-20{fill:url(#D\xE9grad\xE9_sans_nom_157-19);}.cls-21{fill:url(#D\xE9grad\xE9_sans_nom_157-20);}.cls-22{fill:url(#D\xE9grad\xE9_sans_nom_157-21);}.cls-23{fill:url(#D\xE9grad\xE9_sans_nom_157-22);}.cls-24{fill:url(#D\xE9grad\xE9_sans_nom_157-23);}.cls-25{fill:url(#D\xE9grad\xE9_sans_nom_157-24);}.cls-26{fill:url(#D\xE9grad\xE9_sans_nom_157-25);}.cls-27{fill:url(#D\xE9grad\xE9_sans_nom_157-26);}.cls-28{fill:url(#D\xE9grad\xE9_sans_nom_157-27);}.cls-29{fill:url(#D\xE9grad\xE9_sans_nom_157-28);}.cls-30{fill:url(#D\xE9grad\xE9_sans_nom_157-29);}.cls-31{fill:url(#D\xE9grad\xE9_sans_nom_157-30);}.cls-32{fill:url(#D\xE9grad\xE9_sans_nom_157-31);}.cls-33{fill:url(#D\xE9grad\xE9_sans_nom_157-32);}.cls-34{fill:url(#D\xE9grad\xE9_sans_nom_157-33);}.cls-35{fill:url(#D\xE9grad\xE9_sans_nom_157-34);}.cls-36{fill:url(#D\xE9grad\xE9_sans_nom_157-35);}.cls-37{fill:url(#D\xE9grad\xE9_sans_nom_157-36);}.cls-38{fill:url(#D\xE9grad\xE9_sans_nom_157-37);}.cls-39{fill:url(#D\xE9grad\xE9_sans_nom_157-38);}.cls-40{fill:url(#D\xE9grad\xE9_sans_nom_157-39);}.cls-41{fill:url(#D\xE9grad\xE9_sans_nom_157-40);}.cls-42{fill:url(#D\xE9grad\xE9_sans_nom_157-41);}.cls-43{fill:url(#D\xE9grad\xE9_sans_nom_157-42);}.cls-44{fill:url(#D\xE9grad\xE9_sans_nom_157-43);}.cls-45{fill:url(#D\xE9grad\xE9_sans_nom_157-44);}.cls-46{fill:url(#D\xE9grad\xE9_sans_nom_157-45);}.cls-47{fill:url(#D\xE9grad\xE9_sans_nom_157-46);}.cls-48{fill:url(#D\xE9grad\xE9_sans_nom_157-47);}.cls-49{fill:url(#D\xE9grad\xE9_sans_nom_157-48);}.cls-50{fill:url(#D\xE9grad\xE9_sans_nom_157-49);}.cls-51{fill:url(#D\xE9grad\xE9_sans_nom_157-50);}.cls-52{fill:url(#D\xE9grad\xE9_sans_nom_157-51);}.cls-53{fill:url(#D\xE9grad\xE9_sans_nom_157-52);}.cls-54{fill:url(#D\xE9grad\xE9_sans_nom_157-53);}.cls-55{fill:url(#D\xE9grad\xE9_sans_nom_157-54);}.cls-56{fill:url(#D\xE9grad\xE9_sans_nom_157-55);}.cls-57{fill:url(#D\xE9grad\xE9_sans_nom_157-56);}.cls-58{fill:url(#D\xE9grad\xE9_sans_nom_157-57);}.cls-59{fill:url(#D\xE9grad\xE9_sans_nom_157-58);}.cls-60{fill:url(#D\xE9grad\xE9_sans_nom_416);}.cls-61{fill:url(#D\xE9grad\xE9_sans_nom_92);}.cls-62{fill:#424242;opacity:0.42;}.cls-63{fill:#2a2a28;}.cls-64{fill:#f8b71f;}.cls-65{fill:#4c4e4d;}.cls-66{fill:#202120;}.cls-67{fill:#ffd02e;}.cls-68{fill:#1c1c1c;}.cls-69,.cls-70,.cls-72,.cls-73,.cls-74,.cls-75{stroke:#b3b3ba;stroke-width:2px;}.cls-70{stroke-dasharray:6.14 2.05;}.cls-71{opacity:0.67;}.cls-72{stroke-dasharray:5.68 1.89;}.cls-73{stroke-dasharray:5.19 1.73;}.cls-74{stroke-dasharray:5.95 1.98;}.cls-75{stroke-dasharray:6.04 2.01;}.cls-76{clip-path:url(#clip-path);}.cls-77{fill:#282d53;}.cls-77,.cls-79,.cls-81{stroke:#000;}.cls-78{fill:#1b203d;}.cls-79{fill:url(#D\xE9grad\xE9_sans_nom_45);}.cls-80{fill:#171103;}.cls-81{fill:url(#D\xE9grad\xE9_sans_nom_45-2);}.cls-82{fill:url(#D\xE9grad\xE9_sans_nom_67);}.cls-83{fill:url(#D\xE9grad\xE9_sans_nom_67-2);}.cls-84{fill:#0e1129;}.cls-85{clip-path:url(#clip-path-2);}.cls-86{fill:#2d2d2d;}.cls-87{fill:#76af3a;}.cls-88{fill:#898989;}.cls-89{fill:#cecece;opacity:0.46;}.cls-90{clip-path:url(#clip-path-3);}.cls-91{fill:#3c5346;}.cls-92{fill:#111;}.cls-93{fill:#fff;}.cls-94{fill:#52a372;}.cls-95{clip-path:url(#clip-path-4);}.cls-96{fill:#97675e;}.cls-97{fill:#20456e;}.cls-98{fill:#82cec4;}.cls-99{fill:#282b2e;}.cls-100{fill:url(#D\xE9grad\xE9_sans_nom_31);}.cls-101{fill:#143451;}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_157",
    x1: 1509.5,
    y1: 2874.85,
    x2: 1509.5,
    y2: 2831.8,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#614533"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#9e775f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#a07860"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#a77d64"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#b2866b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#c39376"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#d19d7e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#cf9b7d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#c79678"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#ba8c70"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#a77e65"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#9e775f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#9e775f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#9e775f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#9e775f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#9e775f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#9e775f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#b1856b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#d19d7e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#cf9c7d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#c89678"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#bd8d70"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#ac8065"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#966e57"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7b5a45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#70513e"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_157-2",
    x1: 709.5,
    y1: 2874.85,
    x2: 709.5,
    y2: 2831.8,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_157"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_157-3",
    x1: 2854.5,
    y1: 2874.85,
    x2: 2854.5,
    y2: 2831.8,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_157"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_157-4",
    x1: 2309.5,
    y1: 2874.85,
    x2: 2309.5,
    y2: 2831.8,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_157"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_157-5",
    x1: 1937.5,
    y1: 2830.8,
    x2: 1937.5,
    y2: 2787.75,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_157"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_157-6",
    x1: 1137.5,
    y1: 2830.8,
    x2: 1137.5,
    y2: 2787.75,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_157"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_157-7",
    x1: 369,
    y1: 2830.8,
    x2: 369,
    y2: 2787.75,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_157"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_157-8",
    x1: 2668.5,
    y1: 2830.8,
    x2: 2668.5,
    y2: 2787.75,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_157"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_157-9",
    x1: 2070.26,
    y1: 2787.75,
    x2: 2070.26,
    y2: 2744.7,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_157"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_157-10",
    x1: 1369.9,
    y1: 2787.75,
    x2: 1369.9,
    y2: 2744.7,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_157"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_157-11",
    x1: 697.11,
    y1: 2787.75,
    x2: 697.11,
    y2: 2744.7,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_157"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_157-12",
    x1: 187.56,
    y1: 2787.75,
    x2: 187.56,
    y2: 2744.7,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_157"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_157-13",
    x1: 2710.22,
    y1: 2787.75,
    x2: 2710.22,
    y2: 2744.7,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_157"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_157-14",
    x1: 155,
    y1: 2874.85,
    x2: 155,
    y2: 2831.8,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_157"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_157-15",
    x1: 1137.5,
    y1: 2917.9,
    x2: 1137.5,
    y2: 2874.85,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_157"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_157-16",
    x1: 1937.5,
    y1: 2917.9,
    x2: 1937.5,
    y2: 2874.85,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_157"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_157-17",
    x1: 369,
    y1: 2917.9,
    x2: 369,
    y2: 2874.85,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_157"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_157-18",
    x1: 187.5,
    y1: 2960.95,
    x2: 187.5,
    y2: 2917.9,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_157"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_157-19",
    x1: 773.5,
    y1: 2960.95,
    x2: 773.5,
    y2: 2917.9,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_157"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_157-20",
    x1: 1573.5,
    y1: 2960.95,
    x2: 1573.5,
    y2: 2917.9,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_157"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_157-21",
    x1: 2373.5,
    y1: 2960.95,
    x2: 2373.5,
    y2: 2917.9,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_157"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_157-22",
    x1: 2668.5,
    y1: 2917.9,
    x2: 2668.5,
    y2: 2874.85,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_157"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_157-23",
    x1: 405.5,
    y1: 3004,
    x2: 405.5,
    y2: 2960.95,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_157"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_157-24",
    x1: 1209.5,
    y1: 3004,
    x2: 1209.5,
    y2: 2960.95,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_157"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_157-25",
    x1: 2009.5,
    y1: 3004,
    x2: 2009.5,
    y2: 2960.95,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_157"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_157-26",
    x1: 2704.5,
    y1: 3004,
    x2: 2704.5,
    y2: 2960.95,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_157"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_157-27",
    x1: 2886.5,
    y1: 2960.95,
    x2: 2886.5,
    y2: 2917.9,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_157"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_157-28",
    x1: 1509.5,
    y1: 2615.55,
    x2: 1509.5,
    y2: 2572.5,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_157"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_157-29",
    x1: 709.5,
    y1: 2615.55,
    x2: 709.5,
    y2: 2572.5,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_157"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_157-30",
    x1: 2854.5,
    y1: 2615.55,
    x2: 2854.5,
    y2: 2572.5,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_157"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_157-31",
    x1: 2309.5,
    y1: 2615.55,
    x2: 2309.5,
    y2: 2572.5,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_157"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_157-32",
    x1: 1937.5,
    y1: 2571.5,
    x2: 1937.5,
    y2: 2528.45,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_157"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_157-33",
    x1: 1137.5,
    y1: 2571.5,
    x2: 1137.5,
    y2: 2528.45,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_157"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_157-34",
    x1: 369,
    y1: 2571.5,
    x2: 369,
    y2: 2528.45,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_157"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_157-35",
    x1: 2668.5,
    y1: 2571.5,
    x2: 2668.5,
    y2: 2528.45,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_157"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_157-36",
    x1: 2070.26,
    y1: 2528.45,
    x2: 2070.26,
    y2: 2485.4,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_157"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_157-37",
    x1: 1369.9,
    y1: 2528.45,
    x2: 1369.9,
    y2: 2485.4,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_157"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_157-38",
    x1: 697.11,
    y1: 2528.45,
    x2: 697.11,
    y2: 2485.4,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_157"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_157-39",
    x1: 187.56,
    y1: 2528.45,
    x2: 187.56,
    y2: 2485.4,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_157"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_157-40",
    x1: 2710.22,
    y1: 2528.45,
    x2: 2710.22,
    y2: 2485.4,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_157"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_157-41",
    x1: 155,
    y1: 2615.55,
    x2: 155,
    y2: 2572.5,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_157"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_157-42",
    x1: 1137.5,
    y1: 2658.6,
    x2: 1137.5,
    y2: 2615.55,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_157"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_157-43",
    x1: 1937.5,
    y1: 2658.6,
    x2: 1937.5,
    y2: 2615.55,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_157"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_157-44",
    x1: 369,
    y1: 2658.6,
    x2: 369,
    y2: 2615.55,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_157"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_157-45",
    x1: 187.5,
    y1: 2701.65,
    x2: 187.5,
    y2: 2658.6,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_157"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_157-46",
    x1: 773.5,
    y1: 2701.65,
    x2: 773.5,
    y2: 2658.6,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_157"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_157-47",
    x1: 1573.5,
    y1: 2701.65,
    x2: 1573.5,
    y2: 2658.6,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_157"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_157-48",
    x1: 2373.5,
    y1: 2701.65,
    x2: 2373.5,
    y2: 2658.6,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_157"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_157-49",
    x1: 2668.5,
    y1: 2658.6,
    x2: 2668.5,
    y2: 2615.55,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_157"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_157-50",
    x1: 405.5,
    y1: 2744.7,
    x2: 405.5,
    y2: 2701.65,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_157"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_157-51",
    x1: 1209.5,
    y1: 2744.7,
    x2: 1209.5,
    y2: 2701.65,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_157"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_157-52",
    x1: 2009.5,
    y1: 2744.7,
    x2: 2009.5,
    y2: 2701.65,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_157"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_157-53",
    x1: 2704.5,
    y1: 2744.7,
    x2: 2704.5,
    y2: 2701.65,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_157"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_157-54",
    x1: 2886.5,
    y1: 2701.65,
    x2: 2886.5,
    y2: 2658.6,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_157"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_157-55",
    x1: 405.5,
    y1: 2485.4,
    x2: 405.5,
    y2: 2442.35,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_157"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_157-56",
    x1: 1209.5,
    y1: 2485.4,
    x2: 1209.5,
    y2: 2442.35,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_157"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_157-57",
    x1: 2009.5,
    y1: 2485.4,
    x2: 2009.5,
    y2: 2442.35,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_157"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_157-58",
    x1: 2704.5,
    y1: 2485.4,
    x2: 2704.5,
    y2: 2442.35,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_157"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_416",
    x1: 1500,
    x2: 1500,
    y2: 2440.95,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#5c4932"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#6b5943"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#67553f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5c4932"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5c4932"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_92",
    x1: 1500,
    y1: 2442,
    x2: 1500,
    y2: 2356.67,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#7d7d7d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#8c8c8c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#a0a0a0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#aeaeae"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#b6b6b6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#b8b8b8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#b6b6b6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#afafaf"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#a4a4a4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#939393"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#7d7d7d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#7d7d7d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7d7d7d"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path",
    transform: "translate(0 4)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M2264.24,2667.49c-.81-5.47-29.43-26.22-84.2-60.89-5.24-34.37-25.05-88.56-51-116.24s-55.06-41.08-64.68-43.7-70.21-4.37-110.41,12.82-66.14,81.87-66.14,81.87-6.41,10.19-7.28,28.55c-4.66,9-3.79,39.33-2,57.39,1.69,17.45,19.81,20.39,49.82,25.35s84.78,4.37,84.78,4.37,61.47,53.6,72.83,59.14,45.74,29.13,92.35,13.69S2265.69,2677.4,2264.24,2667.49Zm-357.95-52.91c-1,0-1.85-2.73-1.85-6.09s.83-6.1,1.85-6.1,1.85,2.73,1.85,6.1S1907.31,2614.58,1906.29,2614.58Zm65.3,15.33c-2.81,0-5.1-3-5.1-6.7s2.29-6.7,5.1-6.7,5.1,3,5.1,6.7S1974.41,2629.91,1971.59,2629.91Z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_45",
    x1: 1970.57,
    y1: 2641.49,
    x2: 1970.57,
    y2: 2612.64,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#6c3b12"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#7d4a19"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#f2b246"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#faf192"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#f2b246"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#683810"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_45-2",
    x1: 1904.44,
    y1: 2625.46,
    x2: 1904.44,
    y2: 2599.24,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_45"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_67",
    x1: 2021.73,
    y1: 2432.38,
    x2: 2021.73,
    y2: 2657.3,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#282d53",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#252a4f",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#1e2243",
    stopOpacity: 0.39
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#11152e",
    stopOpacity: 0.87
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0e1129"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_67-2",
    x1: 2103.92,
    y1: 2457.43,
    x2: 2103.92,
    y2: 2655.4,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_67"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2",
    transform: "translate(0 4)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M2952.62,2501.05a29.63,29.63,0,0,0-11.26-4.9s.24-5.63-1.47-5.63-15.68-.49-15.68-.49-5.39-8.08-9.31-7.1-3.92,7.84-3.92,7.84-52.66-10.54-84.26-4.9-55.36,34.54-55.61,36.5,8.82,8.32,16.66,5.87,9.8-22.29,33.56-31.11c22-8.15,55.36-.73,59,1.72,1.23,4.9,14,9.55,14,9.55s-38,13.48-66.62,18.37-66.14,8.33-79.37,16.17-11.27,13.23-11.27,13.23-14.7,6.86-18.13,11c-11.51-3.67-15.18-2.69-17.63-5.14.24-3.68-.49-6.13-3.19-6.86s-13,.49-19.84-2.45-14.21-12.25-17.88-10.78-5.39,8.09-5.39,8.09,54.87,50.21,97.49,66.87,68.1,29.64,119.54,20.09c11.76-1.47,18.62-10.29,18.13-16.42v-3.67s9.55-11,13-19.35c3.43,3.92,23,13,29.4,11.51s17.14-14.32,18.61-19.84C2953.11,2581.89,2966.1,2550.05,2952.62,2501.05Zm-6.85,82.07c-6.13,5.63-11,11.51-13.48,10.77s-3.67-24.74-9.06-27.68c-5.2-2.83-10.29-4.65-18.86,0s-11,9.8-13,15.19-12.49,36-31.59,49.48-83.54-8.82-83.54-8.82-11.51-1-18.61-18.12c0,0-1.76-25.24,0-30.13,4.41-12.25,47.76-22.78,52.91-22.78s64.91-7.84,93.82-5.15c15.18-3.92,38-30.62,42.62-34.54,6.12,2.94,7.84,42.14,7.59,47S2951.89,2577.48,2945.77,2583.12Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3",
    transform: "translate(0 4)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M2764.11,2740.36s-45.8-5.16-76.94,3.28c-8.53,3-7.05,1.15-10.26,4.75s-16.86,16-37.65,24.47c-4,1.6-22.17,15.33-32.92,20.85s-20.15,15.29-26.37,20-31.27,21.41-40.48,8.62c-7.53-10.46,1-26.28,10.72-32.78s31.1-23.59,32.67-33.72-15-15.87-19-16.29-31.58-1.15-61.52,4.24c-26.66,4.79-35.44,8.52-57.11,10.46-7.78,2.43-14.7-15.36-6-21.34,7.72-5.71,9-7,9-7s-12.27,5.55-17-5.72,6.19-19.06,16.45-23.55c-.92-8.57,4.56-24.84,39.23-33.6-2.46-9.8,24-18.58,28.4-19.49,6.79-1.4,42.34-4.12,74.49.05,5.56.4,31.83.64,45.77,3.65,16.94,1.18,23.27,1.81,38.74,5.29,0,0,4.33,1.94,13.15,1.26s70-11.22,73.22-13.05S2780.84,2692.06,2764.11,2740.36Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-4",
    transform: "translate(0 4)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M2788.62,2764.44s-45.3,8.52-72.59,25.74c-7.28,5.32-6.4,3.16-8.41,7.55s-11.41,20.23-28.79,34.45c-3.37,2.7-16.69,21.17-25.34,29.6s-14.77,20.54-19.35,26.82-23.6,29.66-36.16,20.14c-10.27-7.78-6.77-25.41.61-34.48s22.8-31.69,21.32-41.83-18.95-10.77-22.95-10-30.53,8.18-57.56,22.13c-24.07,12.41-31.37,18.55-51.52,26.78-6.72,4.6-18.56-10.37-12-18.65,5.7-7.72,6.5-9.31,6.5-9.31s-10.09,8.9-18-.47.32-20,8.81-27.35c-3.4-7.92-2.93-25.08,27.63-43.64-5.23-8.64,17.44-24.8,21.42-27,6.08-3.33,39.26-16.37,71.22-21.83,5.43-1.26,30.61-8.74,44.82-10,16.54-3.85,22.77-5.1,38.58-6.32,0,0,4.71.58,12.95-2.66s63.58-31.29,66.15-34S2790.41,2713.35,2788.62,2764.44Z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_31",
    x1: 1493.92,
    y1: 1684.88,
    x2: 1493.92,
    y2: 1311.88,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#97675e",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#90635b",
    stopOpacity: 0.06
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#624a47",
    stopOpacity: 0.48
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#413839",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#2e2e30",
    stopOpacity: 0.95
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#282b2e"
  })))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "sac") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 1109.5,
    y: 2831.8,
    width: 800,
    height: 43.05
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 309.5,
    y: 2831.8,
    width: 800,
    height: 43.05
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 2709.5,
    y: 2831.8,
    width: 290,
    height: 43.05
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 1909.5,
    y: 2831.8,
    width: 800,
    height: 43.05
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 1537.5,
    y: 2787.75,
    width: 800,
    height: 43.05
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 737.5,
    y: 2787.75,
    width: 800,
    height: 43.05
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 0.5,
    y: 2787.75,
    width: 737,
    height: 43.05
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 2337.5,
    y: 2787.75,
    width: 662,
    height: 43.05
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 1720.08,
    y: 2744.7,
    width: 700.37,
    height: 43.05
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 1019.71,
    y: 2744.7,
    width: 700.37,
    height: 43.05
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 374.5,
    y: 2744.7,
    width: 645.21,
    height: 43.05
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 0.5,
    y: 2744.7,
    width: 374.12,
    height: 43.05
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    x: 2420.45,
    y: 2744.7,
    width: 579.55,
    height: 43.05
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-15",
    x: 0.5,
    y: 2831.8,
    width: 309,
    height: 43.05
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-16",
    x: 737.5,
    y: 2874.85,
    width: 800,
    height: 43.05
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-17",
    x: 1537.5,
    y: 2874.85,
    width: 800,
    height: 43.05
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-18",
    x: 0.5,
    y: 2874.85,
    width: 737,
    height: 43.05
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-19",
    x: 0.5,
    y: 2917.9,
    width: 374,
    height: 43.05
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-20",
    x: 373.5,
    y: 2917.9,
    width: 800,
    height: 43.05
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-21",
    x: 1173.5,
    y: 2917.9,
    width: 800,
    height: 43.05
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-22",
    x: 1973.5,
    y: 2917.9,
    width: 800,
    height: 43.05
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-23",
    x: 2337.5,
    y: 2874.85,
    width: 662,
    height: 43.05
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-24",
    x: 0.5,
    y: 2960.95,
    width: 810,
    height: 43.05
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-25",
    x: 809.5,
    y: 2960.95,
    width: 800,
    height: 43.05
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-26",
    x: 1609.5,
    y: 2960.95,
    width: 800,
    height: 43.05
  })), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-27",
    x: 2409.5,
    y: 2960.95,
    width: 590,
    height: 43.05
  })), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-28",
    x: 2773.5,
    y: 2917.9,
    width: 226,
    height: 43.05
  })), _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-29",
    x: 1109.5,
    y: 2572.5,
    width: 800,
    height: 43.05
  })), _rect29 || (_rect29 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-30",
    x: 309.5,
    y: 2572.5,
    width: 800,
    height: 43.05
  })), _rect30 || (_rect30 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-31",
    x: 2709.5,
    y: 2572.5,
    width: 290,
    height: 43.05
  })), _rect31 || (_rect31 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-32",
    x: 1909.5,
    y: 2572.5,
    width: 800,
    height: 43.05
  })), _rect32 || (_rect32 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-33",
    x: 1537.5,
    y: 2528.45,
    width: 800,
    height: 43.05
  })), _rect33 || (_rect33 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-34",
    x: 737.5,
    y: 2528.45,
    width: 800,
    height: 43.05
  })), _rect34 || (_rect34 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-35",
    x: 0.5,
    y: 2528.45,
    width: 737,
    height: 43.05
  })), _rect35 || (_rect35 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-36",
    x: 2337.5,
    y: 2528.45,
    width: 662,
    height: 43.05
  })), _rect36 || (_rect36 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-37",
    x: 1720.08,
    y: 2485.4,
    width: 700.37,
    height: 43.05
  })), _rect37 || (_rect37 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-38",
    x: 1019.71,
    y: 2485.4,
    width: 700.37,
    height: 43.05
  })), _rect38 || (_rect38 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-39",
    x: 374.5,
    y: 2485.4,
    width: 645.21,
    height: 43.05
  })), _rect39 || (_rect39 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-40",
    x: 0.5,
    y: 2485.4,
    width: 374.12,
    height: 43.05
  })), _rect40 || (_rect40 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-41",
    x: 2420.45,
    y: 2485.4,
    width: 579.55,
    height: 43.05
  })), _rect41 || (_rect41 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-42",
    x: 0.5,
    y: 2572.5,
    width: 309,
    height: 43.05
  })), _rect42 || (_rect42 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-43",
    x: 737.5,
    y: 2615.55,
    width: 800,
    height: 43.05
  })), _rect43 || (_rect43 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-44",
    x: 1537.5,
    y: 2615.55,
    width: 800,
    height: 43.05
  })), _rect44 || (_rect44 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-45",
    x: 0.5,
    y: 2615.55,
    width: 737,
    height: 43.05
  })), _rect45 || (_rect45 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-46",
    x: 0.5,
    y: 2658.6,
    width: 374,
    height: 43.05
  })), _rect46 || (_rect46 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-47",
    x: 373.5,
    y: 2658.6,
    width: 800,
    height: 43.05
  })), _rect47 || (_rect47 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-48",
    x: 1173.5,
    y: 2658.6,
    width: 800,
    height: 43.05
  })), _rect48 || (_rect48 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-49",
    x: 1973.5,
    y: 2658.6,
    width: 800,
    height: 43.05
  })), _rect49 || (_rect49 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-50",
    x: 2337.5,
    y: 2615.55,
    width: 662,
    height: 43.05
  })), _rect50 || (_rect50 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-51",
    x: 0.5,
    y: 2701.65,
    width: 810,
    height: 43.05
  })), _rect51 || (_rect51 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-52",
    x: 809.5,
    y: 2701.65,
    width: 800,
    height: 43.05
  })), _rect52 || (_rect52 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-53",
    x: 1609.5,
    y: 2701.65,
    width: 800,
    height: 43.05
  })), _rect53 || (_rect53 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-54",
    x: 2409.5,
    y: 2701.65,
    width: 590,
    height: 43.05
  })), _rect54 || (_rect54 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-55",
    x: 2773.5,
    y: 2658.6,
    width: 226,
    height: 43.05
  })), _rect55 || (_rect55 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-56",
    x: 0.5,
    y: 2442.35,
    width: 810,
    height: 43.05
  })), _rect56 || (_rect56 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-57",
    x: 809.5,
    y: 2442.35,
    width: 800,
    height: 43.05
  })), _rect57 || (_rect57 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-58",
    x: 1609.5,
    y: 2442.35,
    width: 800,
    height: 43.05
  })), _rect58 || (_rect58 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-59",
    x: 2409.5,
    y: 2442.35,
    width: 590,
    height: 43.05
  })), _rect59 || (_rect59 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-60",
    width: 3000,
    height: 2440.95
  })), _rect60 || (_rect60 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-61",
    y: 2356.67,
    width: 3000,
    height: 85.33
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-62",
    d: "M2608,2553l102.22-114.65S2722,2359,2700,2352c0-22-26-216-123-211S2608,2553,2608,2553Z",
    transform: "translate(0 4)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "sac"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-63",
    d: "M2426.07,2558.57s-149.81,1.71-155.51,0-5.7-2.84-5.7-2.84-17.65-1.71-20.5-2.85-12-4-15.38-12-7.41-23.93-9.12-47.85c-11.39-16.52-20.5-62.66-21.64-72.35s-2.28-38.73.57-49.55a157.72,157.72,0,0,1,5.12-16.52s-1.7-8-.57-10.26,10.26-4,10.83-4,8.54-2.85,8.54-5.13,14.24-113.36,20.51-132.15,29.91-78,50.13-87.73c-4.56-15.38-13.11-56.39-8.55-70.06.57-2.28,3.42-2.28,8-2.28s47.28-8.54,47.28-8.54,7.4-1.14,9.11-2.28,8.23-3.75,12.53,2.28l23.93,47.84,40.44-.56Z",
    transform: "translate(0 4)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-64",
    d: "M2426.07,2295l-134.43-.17s-1.86-28.23,11.39-38.17c6.83-5.13,17.09-6.26,28.48-6.26h94.56Z",
    transform: "translate(0 4)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-65",
    points: "2285.37 2530.68 2291.64 2298.84 2426.07 2298.84 2426.07 2530.68 2285.37 2530.68"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-66",
    d: "M2262,2526.67s14.24-240.38,18.22-254.05,18.23-27.91,26.21-29,55.25-6.84,74.05-8,45.69-3.26,45.69-3.26l-.21,7.09s-109.28,5.86-118.39,10.42-18.8,17.65-19.37,22.78-15.95,254.05-15.95,254.05Z",
    transform: "translate(0 4)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-67",
    d: "M2233,2541.48s8.54-57.53,11.39-95.12,18.23-201.08,15.38-222.73h-4.56s-29.62,241.52-29.62,268.87C2225.56,2511.29,2233,2541.48,2233,2541.48Z",
    transform: "translate(0 4)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-68",
    d: "M2320.69,2158.13h42.72s-4-63.8,0-79.18,9.68-51.27,9.11-56.4a10.56,10.56,0,0,1-2.27-1.7s14.24-13.68,55.82-12V1993.5s-27.91-1.71-52.41,6.84c-4,1.71-10.25,1.14-12.53,3.42s-4,8-10.82,17.65c-8.55,14.25-18.23,20.51-23.36,32.47S2320.12,2134.77,2320.69,2158.13Z",
    transform: "translate(0 4)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-68",
    x: 2383.35,
    y: 2312.51,
    width: 42.72,
    height: 28.48
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-68",
    x: 2290.5,
    y: 2357.51,
    width: 135.57,
    height: 13.1
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-68",
    d: "M2308.16,2354.08s-.57-1.71-3.42-1.71-4.56,4-4.56,4h-4a5.3,5.3,0,0,1-1.7,3.41c-1.71,1.71,0,28.49,0,28.49s-.57,8,6.26,8,7.41-6.84,7.41-6.84-2.28-17.65-2.28-21.64c1.14-.57,2.28-3.42,2.28-3.42h7.4v-10.25Zm-7.41,39.87a4.56,4.56,0,1,1,4.56-4.56A4.56,4.56,0,0,1,2300.75,2394Z",
    transform: "translate(0 4)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-68",
    d: "M2422.65,2229.33l-4.56-1.71s-10.25.57-10.82,1.71-4,3.42-2.85,5.13l1.14,1.13s-2.28,10.26-1.71,12.54,1.71,5.12,5.7,5.12,7.4-1.71,8-4-1.13-11.4-1.13-11.4h5.12a4.45,4.45,0,0,0,2.28-1.71C2424.36,2235,2422.65,2229.33,2422.65,2229.33ZM2410.4,2251c-2.67,0-4.84-1.27-4.84-2.84s2.17-2.85,4.84-2.85,4.85,1.27,4.85,2.85S2413.08,2251,2410.4,2251Z",
    transform: "translate(0 4)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-68",
    d: "M2415.25,2076.67l-8.55-1.14-6.83,8h1.69s-6.25,9.12-6.82,10.26-.57,3.42,0,4,12.53-2.27,13.67-2.84,1.61-11.4,1.61-11.4h12.63v-2.27Zm-6.84,4.56,4-2.28,6.26,1.71,1.14.57Z",
    transform: "translate(0 4)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-69",
    x1: 2270.56,
    y1: 2163.83,
    x2: 2273.56,
    y2: 2163.83
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-70",
    x1: 2275.61,
    y1: 2163.83,
    x2: 2422.04,
    y2: 2163.83
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-69",
    x1: 2423.07,
    y1: 2163.83,
    x2: 2426.07,
    y2: 2163.83
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-71"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-69",
    x1: 2322.4,
    y1: 2159.28,
    x2: 2325.4,
    y2: 2159.28
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-72",
    x1: 2327.29,
    y1: 2159.28,
    x2: 2356.62,
    y2: 2159.28
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-69",
    x1: 2357.56,
    y1: 2159.28,
    x2: 2360.56,
    y2: 2159.28
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-69",
    x1: 2322.4,
    y1: 2130.8,
    x2: 2325.4,
    y2: 2130.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-72",
    x1: 2327.29,
    y1: 2130.8,
    x2: 2356.62,
    y2: 2130.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-69",
    x1: 2357.56,
    y1: 2130.8,
    x2: 2360.56,
    y2: 2130.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-69",
    x1: 2322.4,
    y1: 2130.8,
    x2: 2322.4,
    y2: 2133.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-73",
    x1: 2322.4,
    y1: 2135.53,
    x2: 2322.4,
    y2: 2155.41
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-69",
    x1: 2322.4,
    y1: 2156.28,
    x2: 2322.4,
    y2: 2159.28
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-69",
    x1: 2360.56,
    y1: 2130.8,
    x2: 2360.56,
    y2: 2133.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-73",
    x1: 2360.56,
    y1: 2135.53,
    x2: 2360.56,
    y2: 2155.41
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-69",
    x1: 2360.56,
    y1: 2156.28,
    x2: 2360.56,
    y2: 2159.28
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-69",
    x1: 2322.4,
    y1: 2130.8,
    x2: 2324.8,
    y2: 2132.59
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-74",
    x1: 2326.39,
    y1: 2133.78,
    x2: 2357.36,
    y2: 2156.89
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-69",
    x1: 2358.16,
    y1: 2157.48,
    x2: 2360.56,
    y2: 2159.28
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-69",
    x1: 2360.56,
    y1: 2130.8,
    x2: 2358.16,
    y2: 2132.59
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-74",
    x1: 2356.57,
    y1: 2133.78,
    x2: 2325.6,
    y2: 2156.89
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-69",
    x1: 2324.8,
    y1: 2157.48,
    x2: 2322.4,
    y2: 2159.28
  })), /*#__PURE__*/React.createElement("line", {
    className: "cls-69",
    x1: 2270.56,
    y1: 2170.67,
    x2: 2273.56,
    y2: 2170.67
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-70",
    x1: 2275.61,
    y1: 2170.67,
    x2: 2422.04,
    y2: 2170.67
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-69",
    x1: 2423.07,
    y1: 2170.67,
    x2: 2426.07,
    y2: 2170.67
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-69",
    d: "M2241.51,2526.1a4.73,4.73,0,0,0,2.57,1.45",
    transform: "translate(0 4)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-75",
    d: "M2246,2528.07c21.17,5,110.56,5.75,176,4.39",
    transform: "translate(0 4)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-69",
    d: "M2423.07,2532.44l3-.07",
    transform: "translate(0 4)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-63",
    d: "M2426.07,2558.57s149.81,1.71,155.51,0,5.69-2.84,5.69-2.84,17.66-1.71,20.51-2.85,12-4,15.38-12,7.41-23.93,9.11-47.85c11.4-16.52,20.51-62.66,21.65-72.35s2.28-38.73-.57-49.55a155.81,155.81,0,0,0-5.13-16.52s1.71-8,.57-10.26-10.25-4-10.82-4-8.54-2.85-8.54-5.13-14.24-113.36-20.51-132.15-29.91-78-50.13-87.73c4.56-15.38,13.1-56.39,8.55-70.06-.57-2.28-3.42-2.28-8-2.28s-47.28-8.54-47.28-8.54-7.4-1.14-9.11-2.28-8.23-3.75-12.53,2.28l-23.93,47.84-40.44-.56Z",
    transform: "translate(0 4)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-64",
    d: "M2426.07,2295l134.43-.17s1.86-28.23-11.39-38.17c-6.84-5.13-17.09-6.26-28.48-6.26h-94.56Z",
    transform: "translate(0 4)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-65",
    points: "2566.77 2530.68 2560.5 2298.84 2426.07 2298.84 2426.07 2530.68 2566.77 2530.68"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-66",
    d: "M2590.12,2526.67s-14.24-240.38-18.23-254.05-18.22-27.91-26.2-29-55.25-6.84-74.05-8-45.69-3.26-45.69-3.26l.21,7.09s109.28,5.86,118.39,10.42,18.8,17.65,19.37,22.78,15.95,254.05,15.95,254.05Z",
    transform: "translate(0 4)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-67",
    d: "M2619.17,2541.48s-8.54-57.53-11.39-95.12-18.23-201.08-15.38-222.73H2597s29.62,241.52,29.62,268.87C2626.58,2511.29,2619.17,2541.48,2619.17,2541.48Z",
    transform: "translate(0 4)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-68",
    d: "M2531.45,2158.13h-42.72s4-63.8,0-79.18-9.69-51.27-9.12-56.4a10.75,10.75,0,0,0,2.28-1.7s-14.24-13.68-55.82-12V1993.5s27.91-1.71,52.4,6.84c4,1.71,10.26,1.14,12.54,3.42s4,8,10.82,17.65c8.54,14.25,18.23,20.51,23.35,32.47S2532,2134.77,2531.45,2158.13Z",
    transform: "translate(0 4)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-68",
    x: 2426.07,
    y: 2308.51,
    width: 42.72,
    height: 28.48,
    transform: "translate(4894.86 4649.5) rotate(-180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-68",
    x: 2426.07,
    y: 2353.51,
    width: 135.57,
    height: 13.1,
    transform: "translate(4987.71 4724.12) rotate(-180)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-68",
    d: "M2536.58,2354.08v10.25h7.4s1.14,2.85,2.28,3.42c0,4-2.28,21.64-2.28,21.64s.57,6.84,7.41,6.84,6.26-8,6.26-8,1.71-26.78,0-28.49a5.28,5.28,0,0,1-1.71-3.41h-4s-1.71-4-4.56-4-3.42,1.71-3.42,1.71Zm10.25,35.31a4.56,4.56,0,1,1,4.56,4.56A4.56,4.56,0,0,1,2546.83,2389.39Z",
    transform: "translate(0 4)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-68",
    d: "M2428.35,2236.16a4.45,4.45,0,0,0,2.28,1.71h5.12s-1.71,9.12-1.14,11.4,4,4,8,4,5.12-2.84,5.69-5.12-1.7-12.54-1.7-12.54l1.13-1.13c1.14-1.71-2.27-4-2.84-5.13s-10.83-1.71-10.83-1.71l-4.55,1.71S2427.78,2235,2428.35,2236.16Zm8.54,12c0-1.58,2.17-2.85,4.84-2.85s4.85,1.27,4.85,2.85-2.17,2.84-4.85,2.84S2436.89,2249.7,2436.89,2248.13Z",
    transform: "translate(0 4)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-68",
    d: "M2429.49,2081.23v2.27h12.63s.47,10.83,1.61,11.4,13.1,3.41,13.67,2.84.57-2.84,0-4-6.82-10.26-6.82-10.26h1.69l-6.83-8-8.55,1.14Zm2.84,0,1.14-.57,6.27-1.71,4,2.28Z",
    transform: "translate(0 4)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-69",
    x1: 2581.58,
    y1: 2163.83,
    x2: 2578.58,
    y2: 2163.83
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-70",
    x1: 2576.53,
    y1: 2163.83,
    x2: 2430.09,
    y2: 2163.83
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-69",
    x1: 2429.07,
    y1: 2163.83,
    x2: 2426.07,
    y2: 2163.83
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-71"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-69",
    x1: 2529.74,
    y1: 2159.28,
    x2: 2526.74,
    y2: 2159.28
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-72",
    x1: 2524.85,
    y1: 2159.28,
    x2: 2495.52,
    y2: 2159.28
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-69",
    x1: 2494.58,
    y1: 2159.28,
    x2: 2491.58,
    y2: 2159.28
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-69",
    x1: 2529.74,
    y1: 2130.8,
    x2: 2526.74,
    y2: 2130.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-72",
    x1: 2524.85,
    y1: 2130.8,
    x2: 2495.52,
    y2: 2130.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-69",
    x1: 2494.58,
    y1: 2130.8,
    x2: 2491.58,
    y2: 2130.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-69",
    x1: 2529.74,
    y1: 2130.8,
    x2: 2529.74,
    y2: 2133.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-73",
    x1: 2529.74,
    y1: 2135.53,
    x2: 2529.74,
    y2: 2155.41
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-69",
    x1: 2529.74,
    y1: 2156.28,
    x2: 2529.74,
    y2: 2159.28
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-69",
    x1: 2491.58,
    y1: 2130.8,
    x2: 2491.58,
    y2: 2133.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-73",
    x1: 2491.58,
    y1: 2135.53,
    x2: 2491.58,
    y2: 2155.41
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-69",
    x1: 2491.58,
    y1: 2156.28,
    x2: 2491.58,
    y2: 2159.28
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-69",
    x1: 2529.74,
    y1: 2130.8,
    x2: 2527.34,
    y2: 2132.59
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-74",
    x1: 2525.75,
    y1: 2133.78,
    x2: 2494.77,
    y2: 2156.89
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-69",
    x1: 2493.98,
    y1: 2157.48,
    x2: 2491.58,
    y2: 2159.28
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-69",
    x1: 2491.58,
    y1: 2130.8,
    x2: 2493.98,
    y2: 2132.59
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-74",
    x1: 2495.57,
    y1: 2133.78,
    x2: 2526.54,
    y2: 2156.89
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-69",
    x1: 2527.34,
    y1: 2157.48,
    x2: 2529.74,
    y2: 2159.28
  })), /*#__PURE__*/React.createElement("line", {
    className: "cls-69",
    x1: 2581.58,
    y1: 2170.67,
    x2: 2578.58,
    y2: 2170.67
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-70",
    x1: 2576.53,
    y1: 2170.67,
    x2: 2430.09,
    y2: 2170.67
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-69",
    x1: 2429.07,
    y1: 2170.67,
    x2: 2426.07,
    y2: 2170.67
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-69",
    d: "M2610.63,2526.1a4.72,4.72,0,0,1-2.58,1.45",
    transform: "translate(0 4)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-75",
    d: "M2606.12,2528.07c-21.17,5-110.56,5.75-176,4.39",
    transform: "translate(0 4)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-69",
    d: "M2429.06,2532.44l-3-.07",
    transform: "translate(0 4)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "cls-76"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-77",
    d: "M2264.24,2667.49c-.81-5.47-29.43-26.22-84.2-60.89-5.24-34.37-25.05-88.56-51-116.24s-55.06-41.08-64.68-43.7-70.21-4.37-110.41,12.82-66.14,81.87-66.14,81.87-6.41,10.19-7.28,28.55c-4.66,9-3.79,39.33-2,57.39,1.69,17.45,19.81,20.39,49.82,25.35s84.78,4.37,84.78,4.37,61.47,53.6,72.83,59.14,45.74,29.13,92.35,13.69S2265.69,2677.4,2264.24,2667.49Zm-357.95-52.91c-1,0-1.85-2.73-1.85-6.09s.83-6.1,1.85-6.1,1.85,2.73,1.85,6.1S1907.31,2614.58,1906.29,2614.58Zm65.3,15.33c-2.81,0-5.1-3-5.1-6.7s2.29-6.7,5.1-6.7,5.1,3,5.1,6.7S1974.41,2629.91,1971.59,2629.91Z",
    transform: "translate(0 4)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-78",
    d: "M2084.16,2648.5l126.18,72.6,118.57-53.61L2180,2590s-.29,20.68-3.2,24.76-15.15,12.82-15.15,12.82Z",
    transform: "translate(0 4)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-79",
    cx: 1970.57,
    cy: 2627.06,
    rx: 12.53,
    ry: 14.42
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-80",
    cx: 1969.99,
    cy: 2627.06,
    rx: 6.7,
    ry: 8.3
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-81",
    cx: 1904.44,
    cy: 2612.35,
    rx: 7.57,
    ry: 13.11
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-80",
    cx: 1904.83,
    cy: 2612.35,
    rx: 3.31,
    ry: 7.55
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-82",
    d: "M2013.11,2657s93.22-5.83,148.58-29.43c0,0,18.93-15.15,20.39-25s-28.84-119.45-28.84-119.45-81-51.28-85.36-50.69S1880.26,2463,1880.26,2463l-18.94,164.31,35,25.64,60.89,4.37Z",
    transform: "translate(0 4)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-83",
    d: "M2031.84,2655.4s4-85.79-.09-122.79-5.24-62.64-2.33-75.17c32.34-.58,105.62,28.09,119.38,60.66s31.24,88.5,31.24,88.5.58,14-18.35,21S2120.49,2645.94,2031.84,2655.4Z",
    transform: "translate(0 4)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-84",
    d: "M2016.75,2656.57c-2.92-1.17-3.64.44-3.64.44s61.47,53.6,72.83,59.14,45.74,29.13,92.35,13.69c43.7-14.48,82.28-47.9,85.73-60.18a5.34,5.34,0,0,0,.22-2.17c-7.58,9-13,17.05-45,37.44,0,0-37.29,23.6-65.26,24.47s-34.53-2.18-50-9.47c-3.41-1.61-14.07-6.32-21.26-11.36C2057.38,2690.83,2016.75,2656.57,2016.75,2656.57Z",
    transform: "translate(0 4)"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    className: "cls-85"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-86",
    d: "M2952.62,2501.05a29.63,29.63,0,0,0-11.26-4.9s.24-5.63-1.47-5.63-15.68-.49-15.68-.49-5.39-8.08-9.31-7.1-3.92,7.84-3.92,7.84-52.66-10.54-84.26-4.9-55.36,34.54-55.61,36.5,8.82,8.32,16.66,5.87,9.8-22.29,33.56-31.11c22-8.15,55.36-.73,59,1.72,1.23,4.9,14,9.55,14,9.55s-38,13.48-66.62,18.37-66.14,8.33-79.37,16.17-11.27,13.23-11.27,13.23-14.7,6.86-18.13,11c-11.51-3.67-15.18-2.69-17.63-5.14.24-3.68-.49-6.13-3.19-6.86s-13,.49-19.84-2.45-14.21-12.25-17.88-10.78-5.39,8.09-5.39,8.09,54.87,50.21,97.49,66.87,68.1,29.64,119.54,20.09c11.76-1.47,18.62-10.29,18.13-16.42v-3.67s9.55-11,13-19.35c3.43,3.92,23,13,29.4,11.51s17.14-14.32,18.61-19.84C2953.11,2581.89,2966.1,2550.05,2952.62,2501.05Zm-6.85,82.07c-6.13,5.63-11,11.51-13.48,10.77s-3.67-24.74-9.06-27.68c-5.2-2.83-10.29-4.65-18.86,0s-11,9.8-13,15.19-12.49,36-31.59,49.48-83.54-8.82-83.54-8.82-11.51-1-18.61-18.12c0,0-1.76-25.24,0-30.13,4.41-12.25,47.76-22.78,52.91-22.78s64.91-7.84,93.82-5.15c15.18-3.92,38-30.62,42.62-34.54,6.12,2.94,7.84,42.14,7.59,47S2951.89,2577.48,2945.77,2583.12Z",
    transform: "translate(0 4)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-87",
    d: "M2884.77,2482.93h-65.89l-62,43.6,17.64,2.69,13,1.23,43.12-31.36s36.49-1.22,37.47,0,12.25-.49,12.25-.49,8.33.25,9.8-2.69S2884.77,2482.93,2884.77,2482.93Zm-102.76,39a1.84,1.84,0,1,1,1.84-1.84A1.85,1.85,0,0,1,2782,2521.88Zm75.94-29.15h-25.72a1.35,1.35,0,0,1,0-2.7H2858a1.35,1.35,0,1,1,0,2.7Z",
    transform: "translate(0 4)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-88",
    d: "M2737.06,2556.17s56.59-18.13,118.56-19.11,76.67-20.57,76.67-24c-1.71-3.43,1.23-12.25,5.64-14.95a66.66,66.66,0,0,1,6.61-3.67l-4.65-7.84-14.21-3.67-16.41-.74,1,7.6s1.22.49,1,4.16-6.86,10-13.48,12.49-18.37,3.92-18.37,3.92L2851,2514l-60.26,17.14s-36.26,2.94-36.75,3.92-20.33,10.29-20.33,10.29v10Z",
    transform: "translate(0 4)"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-86",
    d: "M2933.71,2525.55c6.5-6.35,11.7-12.07,13.66-13.73,6.14,2.94,7.85,42.19,7.61,47.09s-2.7,19.13-8.83,24.77-11,11.53-13.49,10.8C2941.24,2571.42,2929.47,2533.4,2933.71,2525.55Z",
    transform: "translate(0 4)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-86",
    d: "M2757.78,2604.53s-1.76-25.27,0-30.17c4.42-12.26,47.83-22.81,53-22.81.49,0,17.66-1.71,23.06-2.2-19.13,4.41-57,17.42-63,20.84-3.43,2-6.43,2.9-7.85,9.82-1.17,5.75,1.43,23.43,4.91,29.67,7.11,12.76,44.88,20.36,64.75,20.6,12.32.16,18.79-4,22.32-6.62,17.9-13.49,17.17-54.69,37-62.76,13.42,1.62,22.68,3,21.44,3a21.18,21.18,0,0,0-8.66,2.82c-8.59,4.66-11,9.81-13,15.21s-12.51,36.05-31.64,49.54-83.64-8.83-83.64-8.83S2764.9,2621.7,2757.78,2604.53Z",
    transform: "translate(0 4)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-88",
    d: "M2915.39,2541.1c6.25-4.21,12.76-10.11,18.32-15.55,9.25,10.31,1.4,69.66-1.05,68.93s-3.68-24.78-9.08-27.72a33.1,33.1,0,0,0-3.56-1.71C2920.15,2557,2916.47,2545.91,2915.39,2541.1Z",
    transform: "translate(0 4)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-89",
    d: "M2757.78,2604.07s-1.76-25.72,0-30.7c4.42-12.48,47.83-23.21,53-23.21s65-8,93.94-5.24c15.2-4,38-31.19,42.67-35.19,6.14,3,7.85,42.93,7.61,47.92s-2.7,19.47-8.83,25.21-11,11.73-13.49,11-3.68-25.21-9.08-28.2c-5.2-2.89-10.3-4.75-18.88,0s-11,10-13,15.47-12.51,36.69-31.64,50.41-83.64-9-83.64-9S2764.9,2621.54,2757.78,2604.07Z",
    transform: "translate(0 4)"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    className: "cls-90"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-91",
    d: "M2764.11,2740.36s-45.8-5.16-76.94,3.28c-8.53,3-7.05,1.15-10.26,4.75s-16.86,16-37.65,24.47c-4,1.6-22.17,15.33-32.92,20.85s-20.15,15.29-26.37,20-31.27,21.41-40.48,8.62c-7.53-10.46,1-26.28,10.72-32.78s31.1-23.59,32.67-33.72-15-15.87-19-16.29-31.58-1.15-61.52,4.24c-26.66,4.79-35.44,8.52-57.11,10.46-7.78,2.43-14.7-15.36-6-21.34,7.72-5.71,9-7,9-7s-12.27,5.55-17-5.72,6.19-19.06,16.45-23.55c-.92-8.57,4.56-24.84,39.23-33.6-2.46-9.8,24-18.58,28.4-19.49,6.79-1.4,42.34-4.12,74.49.05,5.56.4,32.08.63,46,4.15,16.69.93,23.26,1.31,38.48,4.79,0,0,4.33,1.94,13.15,1.26s70-11.22,73.22-13.05S2780.84,2692.06,2764.11,2740.36Z",
    transform: "translate(0 4)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-92",
    d: "M2587,2807.85s-15.34,9.65-11.25-6c4-15.22,16-29,22.68-41.09,6.82-12.26-4.07-27.19-19.53-30.17s-55.75,2.86-68.65,1.35-51.95-9.33-8.25-21.3c10.05-2.47,37.5-6.29,41.43-11.92s.39-5.82-4.38-4.46-33.26,3.43-43.39,2.36-36.53-8.87.7-16.17c15.84-3.34,31.5-3.14,38.53-5.05s12-6.8,11.47-7c0,0-19.63,2.93-29.46,3.86-10.08,1-48.46.95-27.48-10.57,6-2.89,12.24-6.8,53.11-8.62a34.73,34.73,0,0,0,17.32-5.13s-35,2.7-39.61,1.78-13.1-4.58,6.1-7.46-29.62-7.48-29.62-7.48l-84.76,67.82,9.5,72.78,81.72,8,28.44,60,52.69-17.19Z",
    transform: "translate(0 4)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-93",
    d: "M2605.35,2640.21s5.66,18.32,5.24,35.25-3.3,24.81,7.85,26.86,46.11,8.19,46.11,8.19,8.85.58,8.6-12-2.12-43.64-8.11-52.86S2605.35,2640.21,2605.35,2640.21Z",
    transform: "translate(0 4)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-94",
    d: "M2605.35,2640.21s5.66,18.32,5.24,35.25-3.3,24.81,7.85,26.86l5.52,1c6.27-17.64,1.28-52.89-4.09-63.77C2611.5,2639.78,2605.35,2640.21,2605.35,2640.21Z",
    transform: "translate(0 4)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-93",
    d: "M2613.3,2684.48l10.08-.2,0,2.29-6.8.14,6.82.78,0,1.62-6.63,1.1,6.65-.13.05,2.29-10.08.2-.07-3.39c.6-.12,1.32-.23,2.14-.36l2.55-.42-4.72-.51Z",
    transform: "translate(0 4)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-93",
    d: "M2618.28,2681l.17,2.36-.55,0a3.86,3.86,0,0,1-1.49-.11,2,2,0,0,1-1-.82,3.28,3.28,0,0,1-.53-1.69,3.41,3.41,0,0,1,.31-2,1.69,1.69,0,0,1,1-.85,16.82,16.82,0,0,1,2.69-.34l4.14-.31.18,2.44-.74.06a1.58,1.58,0,0,1,.71.54,1.66,1.66,0,0,1,.29.85,2.16,2.16,0,0,1-.28,1.24c-.22.38-.75.6-1.58.67l-.67,0a2,2,0,0,1-1.29-.2,4.18,4.18,0,0,1-.89-1.39,3.92,3.92,0,0,0-.75-1.27,1.84,1.84,0,0,0-.69,0,2.53,2.53,0,0,0-.83.16.32.32,0,0,0-.17.34q0,.26.18.3a3.76,3.76,0,0,0,.86,0Zm1.07-.87a1.87,1.87,0,0,0,.79.64,2.83,2.83,0,0,0,.86,0,2.28,2.28,0,0,0,.82-.15.32.32,0,0,0,.16-.34.31.31,0,0,0-.17-.3,2.43,2.43,0,0,0-.77,0Z",
    transform: "translate(0 4)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-93",
    d: "M2614.45,2671.85l4,.65,4.19-1.59.21,2.44c-1.06.33-2,.6-2.75.79,1,.09,1.94.18,2.85.3l.18,2.1-4.39-.7-3.84,1.42-.18-2.09c1.65-.49,2.59-.76,2.82-.8-1.43-.12-2.4-.22-2.92-.3Z",
    transform: "translate(0 4)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-93",
    d: "M2612.94,2668.35l1.32-.06.12,2.58-1.31.07Zm1.82-.09,8.25-.4.13,2.59-8.25.4Z",
    transform: "translate(0 4)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-93",
    d: "M2612.3,2664.14l1.27-.1a3.33,3.33,0,0,0,.14.91c.06.09.2.13.42.11l.26,0-.08-1.05,1.3-.1,0,.59,6.74-.51.19,2.51-6.74.51,0,.52-1.3.1,0-.52a7.45,7.45,0,0,1-1.09,0,1,1,0,0,1-.51-.24,1.48,1.48,0,0,1-.38-.6,5,5,0,0,1-.2-1.22Z",
    transform: "translate(0 4)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-93",
    d: "M2612,2660.66l10-.94.24,2.58-10,.94Z",
    transform: "translate(0 4)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-93",
    d: "M2616.83,2653.84l.28,3.24,1.78-.16a2.08,2.08,0,0,0,.72-.14.32.32,0,0,0,.13-.32.4.4,0,0,0-.25-.37,2.26,2.26,0,0,0-.83,0l-1.09.09-.21-2.37.61-.05a5.18,5.18,0,0,1,1.18,0,2.53,2.53,0,0,1,.92.37,2.15,2.15,0,0,1,.77.84,3.28,3.28,0,0,1,.35,1.34,4.06,4.06,0,0,1-.1,1.42,2.19,2.19,0,0,1-.55,1,2.4,2.4,0,0,1-.84.55,5.81,5.81,0,0,1-1.39.25l-2.4.21a4.32,4.32,0,0,1-1.73-.14,2,2,0,0,1-1-.88,3.35,3.35,0,0,1-.46-1.49,3.41,3.41,0,0,1,.25-1.78,2.14,2.14,0,0,1,1-1.05,5,5,0,0,1,1.83-.44Zm-1.12,2.62-.6.06a2.63,2.63,0,0,0-.82.14.25.25,0,0,0-.16.29c0,.18.07.28.18.31a3.4,3.4,0,0,0,.86,0l.6-.05Z",
    transform: "translate(0 4)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-93",
    d: "M2611.5,2648.9l4.06.21,4-2,.48,2.4c-1,.45-1.91.81-2.66,1.09,1,0,2,0,2.87,0l.41,2.07-4.44-.22-3.66,1.83-.41-2.06c1.59-.66,2.49-1,2.71-1.1-1.43,0-2.4,0-2.93,0Z",
    transform: "translate(0 4)"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    className: "cls-95"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-91",
    d: "M2788.62,2764.44s-45.3,8.52-72.59,25.74c-7.28,5.32-6.4,3.16-8.41,7.55s-11.41,20.23-28.79,34.45c-3.37,2.7-16.69,21.17-25.34,29.6s-14.77,20.54-19.35,26.82-23.6,29.66-36.16,20.14c-10.27-7.78-6.77-25.41.61-34.48s22.8-31.69,21.32-41.83-18.95-10.77-22.95-10-30.53,8.18-57.56,22.13c-24.07,12.41-31.37,18.55-51.52,26.78-6.72,4.6-18.56-10.37-12-18.65,5.7-7.72,6.5-9.31,6.5-9.31s-10.09,8.9-18-.47.32-20,8.81-27.35c-3.4-7.92-2.93-25.08,27.63-43.64-5.23-8.64,17.44-24.8,21.42-27,6.08-3.33,39.26-16.37,71.22-21.83,5.43-1.26,30.85-8.82,45.22-9.56,16.22-4,22.61-5.58,38.18-6.72,0,0,4.71.58,12.95-2.66s63.58-31.29,66.15-34S2790.41,2713.35,2788.62,2764.44Z",
    transform: "translate(0 4)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-92",
    d: "M2639.1,2881s-11.83,13.74-12.5-2.39c-.66-15.73,6.72-32.45,9.6-45.95,2.92-13.72-11.88-24.79-27.53-23.1s-52.45,19.12-65.23,21.46-52.39,6.34-14.14-17.94c8.88-5.31,34-17,36.1-23.56s-1.34-5.68-5.5-3-30.78,13-40.77,15-37.53,2.25-4.09-15.66c14.16-7.85,29.19-12.26,35.35-16.15s9.46-10,8.9-10.1c0,0-17.91,8.57-27,12.34-9.36,3.88-46,15.15-29.37-2,4.89-4.53,9.7-10.1,48.23-23.84a34.63,34.63,0,0,0,15.05-10s-32.71,12.89-37.34,13.35-13.87-.53,3.64-8.93-30.51,1.56-30.51,1.56l-61.1,89.73,30.47,66.77,80.45-16.37,44.83,49,45.31-31.92Z",
    transform: "translate(0 4)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-93",
    d: "M2607.44,2715.35s10.79,15.85,15.36,32.15,4.13,24.68,15.39,23.37,46.49-5.72,46.49-5.72,8.63-2.05,4.68-14-14.84-41.09-23.28-48.14S2607.44,2715.35,2607.44,2715.35Z",
    transform: "translate(0 4)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-94",
    d: "M2607.44,2715.35s10.79,15.85,15.36,32.15,4.13,24.68,15.39,23.37l5.58-.66c.81-18.71-14.31-50.94-22.65-59.76C2613.19,2713.12,2607.44,2715.35,2607.44,2715.35Z",
    transform: "translate(0 4)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-93",
    d: "M2628,2755.33l9.58-3.15.71,2.17-6.46,2.13,6.75-1.26.51,1.55-6,3,6.32-2.08.72,2.18-9.58,3.15-1.06-3.22c.54-.29,1.19-.61,1.94-1l2.32-1.15-4.66.9Z",
    transform: "translate(0 4)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-93",
    d: "M2631.76,2750.5l.86,2.19-.51.2a3.84,3.84,0,0,1-1.46.34,2.09,2.09,0,0,1-1.18-.49,4.16,4.16,0,0,1-1.28-3.43,1.77,1.77,0,0,1,.75-1.13,16.56,16.56,0,0,1,2.47-1.1l3.86-1.51.89,2.27-.68.27a1.66,1.66,0,0,1,.83.31,1.75,1.75,0,0,1,.53.73,2.12,2.12,0,0,1,.09,1.27c-.09.43-.53.8-1.31,1.1l-.63.25a2,2,0,0,1-1.28.19,4.17,4.17,0,0,1-1.26-1.07,4.38,4.38,0,0,0-1.1-1,2,2,0,0,0-.67.17,2.34,2.34,0,0,0-.75.4.33.33,0,0,0-.06.37c.06.16.15.24.27.23a3.1,3.1,0,0,0,.82-.25Zm.77-1.16a1.87,1.87,0,0,0,.94.38,2.74,2.74,0,0,0,.84-.22,2.58,2.58,0,0,0,.74-.38.33.33,0,0,0,0-.38.29.29,0,0,0-.25-.23,2.39,2.39,0,0,0-.74.21Z",
    transform: "translate(0 4)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-93",
    d: "M2625.43,2742.91l4-.55,3.54-2.75.92,2.26c-.91.64-1.71,1.16-2.4,1.57,1-.21,1.92-.4,2.82-.55l.79,2-4.41.62-3.25,2.49-.79-1.95q2.16-1.42,2.46-1.59c-1.4.31-2.35.5-2.87.57Z",
    transform: "translate(0 4)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-93",
    d: "M2623,2740l1.23-.44.88,2.43-1.23.45Zm1.71-.61,7.77-2.82.88,2.44-7.77,2.81Z",
    transform: "translate(0 4)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-93",
    d: "M2621.11,2736.18l1.19-.47a3.19,3.19,0,0,0,.4.83c.08.07.22.06.43,0l.24-.09-.38-1,1.22-.48.21.56,6.29-2.47.92,2.34-6.29,2.47.19.48-1.22.48-.18-.48a6.35,6.35,0,0,1-1,.34.86.86,0,0,1-.56-.08,1.43,1.43,0,0,1-.53-.45,5,5,0,0,1-.55-1.12Z",
    transform: "translate(0 4)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-93",
    d: "M2619.79,2732.94l9.32-3.85,1,2.4-9.32,3.84Z",
    transform: "translate(0 4)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-93",
    d: "M2622.42,2725l1.22,3,1.66-.68a2,2,0,0,0,.63-.34.33.33,0,0,0,0-.35.39.39,0,0,0-.35-.28,2.43,2.43,0,0,0-.8.23l-1,.41-.9-2.21.57-.23a5.54,5.54,0,0,1,1.12-.36,2.53,2.53,0,0,1,1,.09,2.31,2.31,0,0,1,1,.57,3.27,3.27,0,0,1,.73,1.18,4,4,0,0,1,.32,1.39,2.21,2.21,0,0,1-.87,1.89,6.07,6.07,0,0,1-1.25.65l-2.24.9a4,4,0,0,1-1.69.37,2,2,0,0,1-1.25-.53,3.41,3.41,0,0,1-.89-1.29,3.53,3.53,0,0,1-.28-1.77,2.2,2.2,0,0,1,.63-1.29,4.92,4.92,0,0,1,1.62-1Zm-.3,2.84-.56.23a3.11,3.11,0,0,0-.75.37.27.27,0,0,0-.06.33q.09.24.27.24a3.41,3.41,0,0,0,.81-.26l.56-.23Z",
    transform: "translate(0 4)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-93",
    d: "M2615.87,2721.85l4-1,3.22-3.12,1.16,2.15c-.84.73-1.58,1.34-2.22,1.82.95-.32,1.86-.6,2.74-.85l1,1.85-4.31,1.09-3,2.83-1-1.85c1.33-1.1,2.08-1.72,2.27-1.85-1.35.46-2.29.75-2.79.88Z",
    transform: "translate(0 4)"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-96",
    d: "M1299,1870.79s9.66-223.59-4.82-273.46-28.15-185.79-39.41-246.92c0-96.52,68.69-216.4,148-248.53,93.3-37.8,208.31-29,263.81,19.3s87.67,114.21,89.28,152,13.58,343.32.71,372.27-23.32,31.37-46.65,33.78-111.71,12.18-111.71,12.18l-8.84,179.36Z",
    transform: "translate(0 4)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-97",
    d: "M1228.52,1788.92c37.52-5.56,80.35-10.62,80.35-10.62s-7.42,25.35,16.7,36.48,175,18.55,195.4,10.51,11.13-16.69,11.13-16.69,244.68,78.92,269.87,106.19c60,65,158,1085.21,158,1085.21H902.93s11.36-881.94,86.27-1036.17C1021,1837.6,1228.46,1794.05,1228.52,1788.92Z",
    transform: "translate(0 4)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-98",
    d: "M1254.78,1806.45c12.87,29,124.66,72.38,205.9,64.34s167.29-11.26,181.77-27.35,18-15.16,18-15.16-21.18-57.22-48.52-65.27-78,14.48-163.28,25.74c-19.2,2.54-167.29,5.63-146.48-49C1287.75,1750.15,1241.91,1777.49,1254.78,1806.45Z",
    transform: "translate(0 4)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-99",
    d: "M1254.78,1350.41s-23.33-8-29-38.61,0-37.8,14.48-45.84c-11.26-18.5-8.85-25.74-.8-32.17-8-5.63-24.13-40.22,10.45-57.11,0-15.28,12.07-23.32,22.52-16.89-4.82-31.37,10.46-49.06,37-49.06-4.83-14.48,12.87-38.61,35.39-40.22,0-17.69,20.76-51.07,51.8-40.41,10.13-30.37,47.13-31.17,64-24.74,0-16.08,42.63-39.41,63.54-20.91,9.65-11.26,49.06-25.73,75.6,15.28,29.76-16.08,62.74-18.49,74.8,23.33,0,0,42.63-8.85,43.43,36.19,24.13-2.41,37.81,50.67,20.11,57.91,34.59,15.28,24.93,45,18.5,56.3,24.93,10.46,24.13,45,13.67,59.52,16.89,22.52-17.69,41.83-17.69,41.83s-.81,32.17-33,60.32c0,0-53.08,19.3-103,8C1586.68,1336.39,1312.69,1431.64,1254.78,1350.41Z",
    transform: "translate(0 4)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-100",
    d: "M1254.78,1350.41c-1.8-1.89,25.07,186.65,35.1,230.35,10,28.66,10.84,69.11,11,76.49,29.49-.4,204,54.29,241,10.86,23.33-53.89,89.28-84.45,85.26-141.56s8.85-123.06,56.3-122.25c15.28,10.45,15.28,41,15.28,41s0,17.69,17.7,0c0-30.57-8.85-63.48,8.84-79.63s0-53.81,0-53.81Z",
    transform: "translate(0 4)"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-101",
    points: "1642.14 2155.81 1684.82 2654.37 1752.02 3004 1714.66 3004 1663.94 2648.92 1642.14 2155.81"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-98",
    d: "M1693,2872.86s-376.87,39-622.07-57.21c0,21.8.91,40.87.91,40.87,139.82,62.42,359.62,100.8,631.73,77.77Z",
    transform: "translate(0 4)"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-101",
    points: "1070.93 3004 1070.93 2482.74 1070.93 2134.93 1050 3004 1070.93 3004"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSituationSac);
export default __webpack_public_path__ + "static/media/situation_sac.5522c0d6ec3ba437fedab250d7289a39.svg";
export { ForwardRef as ReactComponent };